import { useDeviceType } from '@cian/ui-kit';

import { Author } from '../../../components/Author';
import { RatingInsideAuthor } from '../../../components/RatingInsideAuthor';
import { IReview } from '../../../types/reviews';

export function AuthorContainer({
  user,
  rating,
  date,
}: Pick<IReview, 'user' | 'date'> & Partial<Pick<IReview, 'rating'>>) {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  return (
    <Author
      name={user.name}
      date={date}
      avatarUrl={user.avatarUrl}
      rating={<RatingInsideAuthor rating={rating} showFullStars={isDesktop} />}
    />
  );
}
